import { useNavigate } from "react-router-dom";
import TableFilter from "./tableFilter";

function SuccessStorie() {
  const navigate = useNavigate();
  return (
    <>
      <div className="content-wrapper">
        <div
          className="content-heading d-flex
                          justify-content-between"
        >
          <div>Success Stories</div>
          <div>
            <button
              className="btn btn-labeled btn-success"
              type="button"
              style={{ fontSize: "17px" }}
              onClick={() => navigate("/admin/success-stories/new")}
            >
              <span className="btn-label">
                <em className="fas fa-plus"></em>
              </span>
              New Success Storie
            </button>
          </div>
        </div>
        <TableFilter />
      </div>
    </>
  );
}

export default SuccessStorie;
